<div class="content">
  @if (isHeaderVisible) {
    <cosmos-header [isSidebarVisible]="isSideBarVisible$ | async"></cosmos-header>
  }
  @for (banner of bannerTopics(); track banner) {
    <coin-c-maintenance-banner
      [class.small-width]="!(sideBarCollapsed$ | async)"
      [class.full-width]="sideBarCollapsed$ | async"
      [topic]="banner"
      (close)="closeBanner(banner)"></coin-c-maintenance-banner>
  }
  <main
    [class.full-height]="!isHeaderVisible"
    [class.full-width]="!(isSideBarVisible$ | async)"
    [class.banner-visible]="bannerTopics()?.length > 0">
    <router-outlet></router-outlet>
    @if (isSideBarVisible$ | async) {
      <cosmos-sidebar role="navigation"></cosmos-sidebar>
    }
  </main>
  <footer></footer>
</div>
